<template>
    <v-dialog v-model="value" max-width="500px" persistent>
        <v-card>
            <v-card-title>
                <span class="text-h5">
                    Novo cartão
                    <v-icon right>
                        mdi-credit-card-plus-outline
                    </v-icon>
                </span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-alert v-if="error_message" type="error">
                        {{ error_message }}
                    </v-alert>
                    <v-form ref="formAdd">
                        <v-row>
                            <v-col cols="6">
                                <v-text-field
                                    v-model="name"
                                    label="Nome do cartão"
                                    :rules="name_rules"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <base-text-money
                                    v-model="limit"
                                    label="Limite do cartão"
                                    :rules="limit_rules"
                                ></base-text-money>
                            </v-col>
                            <v-col cols="6">
                                <v-select
                                    v-model="due_date"
                                    label="Dia do vencimento"
                                    :rules="due_date_rules"
                                    :items="list_dias"
                                ></v-select>
                            </v-col>
                            <v-col cols="6">
                                <base-date-picker
                                    v-model="closing_date"
                                    label="Dia do fechamento"
                                    :rules="closing_date_rules"
                                ></base-date-picker>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    :disabled="loading"
                    @click="close"
                >
                    Cancelar
                </v-btn>
                <v-btn
                    color="success"
                    text
                    :disabled="loading"
                    @click="create"
                >
                    Salvar
                </v-btn>
            </v-card-actions>
            <v-progress-linear
                v-if="loading"
                indeterminate
                height="6"
            ></v-progress-linear>
        </v-card>
        <base-notify
            v-model="show_notify"
            :type="notify_type"
            :message="notify_message"
        >
        </base-notify>
    </v-dialog>
</template>

<script>
import BaseNotify from "../../../components/BaseNotify";
import BaseTextMoney from "../../../components/BaseTextMoney";
import BaseDatePicker from "../../../components/BaseDatePicker";
import { mapActions } from "vuex";

export default {
    components: {
        BaseNotify,
        BaseTextMoney,
        BaseDatePicker
    },
    props: {
        value: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            name: null,
            name_rules: [
                v => !!v || "Digite um nome",
            ],
            limit: null,
            limit_rules: [
                v => !!v || "Informe um valor limite",
            ],
            due_date: null,
            due_date_rules: [
                v => !!v || "Informe uma data de vencimento",
            ],
            closing_date: null,
            closing_date_rules: [
                v => !!v || "Informe uma data de fechamento",
            ],
            list_dias: Array.from({length: 31}, (_, i) => i + 1),
            loading: false,
            error_message: null,
            show_notify: false,
            notify_type: null,
            notify_message: ""
        };
    },
    methods: {
        ...mapActions("credit_card", ["ActionDoCreateCreditCard"]),
        close() {
            this.$refs.formAdd.reset();
            this.$emit("close");
            this.$emit("input", false);
        },
        create() {
            this.loading = true;

            if (this.$refs.formAdd.validate()) {
                try {
                    this.ActionDoCreateCreditCard({
                        name: this.name,
                        limit: this.limit.replace(/[^0-9]+/g, ""),
                        due_date: this.due_date,
                        closing_date: this.closing_date
                    }).then(response => {
                        this.error_mesasge = null;

                        if (response.credit_card) {
                            this.show_notify = true;
                            this.notify_type = "success";
                            this.notify_message = "Cartão salvo com sucesso!";
                            this.loading = false;
                            this.$refs.formAdd.reset();
                            this.close();
                        } else {
                            this.show_notify = true;
                            this.notify_type = "error";
                            this.notify_message = "Ocorreu um erro!";
                            this.loading = false;
                            this.error_mesasge = response.error;
                        }
                    });
                } catch (error) {
                    this.show_notify = true;
                    this.notify_type = "error";
                    this.notify_message = "Ocorreu um erro!";
                    this.loading = false;
                    this.error_mesasge = error.response.data.error;
                }
            } else {
                this.loading = false;
            }
        }
    }
};
</script>